module.exports = __webpack_public_path__ + "static/media/IDLEUSDC.a15d1903.png";